import { render, staticRenderFns } from "./MenuReg.vue?vue&type=template&id=03357c58&scoped=true"
import script from "./MenuReg.vue?vue&type=script&lang=js"
export * from "./MenuReg.vue?vue&type=script&lang=js"
import style0 from "./MenuReg.vue?vue&type=style&index=0&id=03357c58&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03357c58",
  null
  
)

export default component.exports